export const getStyled = (theme, open) => ({
  drawer: {
    width: open ? 350 : 0,
    flexShrink: 0,
    position: 'relative',
  },

  drawerPaper: {
    width: 350,
    display: 'flex',
    borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
  },

  header: {
    display: 'flex',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    minHeight: '50px',
    justifyContent: 'flex-start',
  },

  content: {
    display: 'flex',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
    flexDirection: 'column',
    padding: '8px 0px 8px 8px',
    height: '100%',
    justifyContent: 'flex-start',
  },

  contactAvatar: {
    margin: 15,
    width: 160,
    height: 160,
    borderRadius: 10,
  },

  contactHeader: {
    display: 'flex',
    padding: 8,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
    borderColor: '#bdbdbd',

    '& > *': {
      margin: 4,
    },
  },

  buttonBlock: {
    color: '#FFF',
    backgroundColor: 'rgb(229, 57, 53)',
    borderColor: theme.palette.mode === 'light' ? 'rgb(126, 2, 0) ' : '#FFF',

    '&:hover': {
      backgroundColor: 'rgba(229, 57, 53, 0.2)',
      color: theme.palette.mode === 'light' ? 'rgb(126, 2, 0) ' : '#FFF',
    },
    width: '200px',
    marginBottom: theme.spacing(1),
  },

  buttonEdit: {
    color: '#FFF',
    backgroundColor:
      theme.palette.mode === 'light' ? 'rgb(21, 32, 43)' : 'rgb(29, 161, 242)',
    borderColor: theme.palette.mode === 'light' ? 'rgb(21, 32, 43)' : '#FFF',

    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'ligth'
          ? 'rgba(21, 32, 43, 0.2)'
          : 'rgba(29, 161, 242, 0.2)',
      color: theme.palette.mode === 'light' ? 'rgb(21, 32, 43)' : '#FFF',
    },
    width: '200px',
    marginBottom: theme.spacing(1),
  },

  contactDetails: {
    marginTop: 8,
    padding: 8,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#192734',
  },
  contactExtraInfo: {
    marginTop: 4,
    padding: 6,
  },

  messageMedia: {
    objectFit: 'cover',
    margin: 15,
    width: 140,
    height: 140,
    borderRadius: 10,
  },
});
